<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <zestawieniaMenu/>
        <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Karty ewidencji czasu pracy</h4>
            </div>
          </div>
        </div>

        <!-- filtry -->
        <div class="widget-content">
          <div class="row col-12">
            <div class="col-auto">
              <select v-model="selectedDepartament" class="form-select form-sm mb-2" style="width: 360px;"
                      @change="loadData">
                <option value="0">WSZYSTKIE DZIAŁY</option>
                <option v-for="dep in departaments" :key="dep.id" :value="dep.id">{{ dep.name }}</option>
              </select>
            </div>
            <div class="col-auto">
              <select v-model="selectedMonth" class="form-select form-sm mb-2" style="width: 140px;" @change="loadData">
                <option v-for="(month, i) in months" :key="i" :value="i+1">{{ month }}</option>
              </select>
            </div>
            <div class="col-auto">
              <select v-model="selectedYear" class="form-select form-sm mb-2" style="width: 140px;" @change="loadData">
                <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
              </select>
            </div>
          </div>

          <!-- tabela użytkowników -->
          <div v-for="user in users" :key="user.userId" class="user-card mb-4">
            <h5>{{ user.userName }}</h5>
            <div class="table-responsive">
              <table class="table table-bordered table-hover text-center">
                <thead>
                <tr>
                  <th class="bg-gray-100"></th>
                  <th v-for="day in getDaysInMonth(selectedMonth)" :key="'head-' + day" class="bg-gray-100">
                    {{ day }}
                  </th>
                </tr>
                </thead>
                <tbody>
                <!-- wiersz: godziny -->
                <tr>
                  <td class="bg-gray-100 text-start"><strong>godz.</strong></td>
                  <td v-for="day in getDaysInMonth(selectedMonth)"
                      :key="'hours-' + day"
                      :class="getCellClassForUser(user, day, selectedMonth, 'hours')">
                    {{ getCellValueForUser(user, day, selectedMonth, 'hours') }}
                  </td>
                </tr>
                <tr>
                  <td class="bg-gray-100 text-start"><strong>czas</strong></td>
                  <td v-for="day in getDaysInMonth(selectedMonth)"
                      :key="'sum-' + day"
                      :class="getCellClassForUser(user, day, selectedMonth, 'hours')">
                    {{ getDayTotalTime(user, day, selectedMonth) }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import zestawieniaMenu from "@/Pages/Kadry/parts/zestawieniaMenu.vue";
import axios from "axios";

export default {
  components: {AppLayout, zestawieniaMenu},
  props: {departaments: Array},
  data() {
    const today = new Date();
    return {
      users: [],
      selectedYear: today.getFullYear(),
      selectedMonth: today.getMonth() + 1,
      selectedDepartament: 1,
      months2: ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'],
      months: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
      years: Array.from({length: 11}, (_, i) => today.getFullYear() - 10 + i),
    };
  },
  methods: {

    monthName2(month) {
      return this.months2[month - 1];
    },
    monthName(month) {
      return this.months[month - 1];
    },

    getTotalHoursForUserMonth(user, month) {
      return this.getDaysInMonth(month).reduce((sum, day) => {
        if (this.isWeekend(month, day) || this.isHoliday(this.getDateString(day, month))) return sum;
        return sum + (user.liczba_godzin ?? 8);
      }, 0);
    },
    getCellValueForUser(user, day, month, type) {
      const key = this.getDateString(day, month);
      if (type === 'days') return day;

      const dayData = user.days?.[key];
      if (!dayData || !Array.isArray(dayData.periods)) return '';
      return dayData.periods.join(',\n');
    },

    getDayTotalTime(user, day, month) {
      const key = this.getDateString(day, month);
      const dayData = user.days?.[key];
      if (!dayData || !Array.isArray(dayData.periods)) return '';

      let totalMinutes = 0;
      dayData.periods.forEach(range => {
        if (!range.includes('Korekta')) {
          const [start, end] = range.split('-').map(t => t.split(':').map(Number));
          totalMinutes += (end[0] * 60 + end[1]) - (start[0] * 60 + start[1]);
        }
      });

      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      return totalMinutes > 0 ? `${hours}:${String(minutes).padStart(2, '0')}` : '';
    },


    getCellClassForUser(user, day, month, type) {
      const key = this.getDateString(day, month);
      if (this.isWeekend(month, day) || this.isHoliday(key)) {
        return 'bg-light text-danger'; // przykładowa klasa dla weekendów/świąt
      }
      return '';
    },

    getDateString(day, month) {
      return `${this.selectedYear}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    },

    isWeekend(month, day) {
      const d = new Date(this.selectedYear, month - 1, day);
      return d.getDay() === 0 || d.getDay() === 6;
    },

    getPolishHolidays(year) {
      const format = d => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
      const fixed = [`${year}-01-01`, `${year}-01-06`, `${year}-05-01`, `${year}-05-03`, `${year}-08-15`, `${year}-11-01`, `${year}-11-11`, `${year}-12-24`, `${year}-12-25`, `${year}-12-26`];
      const easter = this.getEasterDate(year);
      fixed.push(format(easter), format(new Date(easter.getTime() + 86400000)), format(new Date(easter.getTime() + 60 * 86400000)));
      return fixed;
    },

    isHoliday(dateStr) {
      const year = parseInt(dateStr.substr(0, 4));
      return this.getPolishHolidays(year).includes(dateStr);
    },

    getEasterDate(year) {
      const f = Math.floor;
      const G = year % 19;
      const C = f(year / 100);
      const H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30;
      const I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11));
      const J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7;
      const L = I - J;
      const month = 3 + f((L + 40) / 44);
      const day = L + 28 - 31 * f(month / 4);
      return new Date(year, month - 1, day);
    },

    async loadData() {
      try {
        const res = await axios.get(route("kadry.kartyOdbicia"), {
          params: {
            departament: this.selectedDepartament,
            rok: this.selectedYear,
            miesiac: this.selectedMonth,
          },
        });
        console.log("Ilu userów przyszło:", res.data.users.length);
        console.log("Lista userów:", res.data.users);
        this.users = res.data.users;
      } catch (e) {
        console.error("Błąd pobierania:", e);
      }
    },

    getDaysInMonth(month) {
      return Array.from({length: new Date(this.selectedYear, month, 0).getDate()}, (_, i) => i + 1);
    },

    formatDate(day, month, year) {
      return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>
<style scoped>
table th, table td {
  min-width: 32px;
  height: 32px;
  text-align: center;
}

.bg-Lightblue {
  background-color: #5fb2d8;
}

.bg-gray-100 {
  background-color: #f5f5f5;
  color: black;
}

.bg-gray-50 {
  background-color: #ddd9c3;
  color: black;
}

.text-white {
  color: white;
}

.text-black {
  color: black;
}

.text-red {
  color: red;
}

.text-green {
  color: green;
}

.text-blue {
  color: blue;
}
</style>
